const twareasDatazh = []
const countryData = [{ ID: 4, Name: '中国(台湾)' }]
const provinceData = [{ Country: 4, ID: 27, Name: '台湾省' }]
const cityData = [
  { Province: 27, ID: 316, Name: '台北市' },
  { Province: 27, ID: 317, Name: '高雄市' },
  { Province: 27, ID: 318, Name: '台南市' },
  { Province: 27, ID: 319, Name: '台中市' },
  { Province: 27, ID: 320, Name: '金门县' },
  { Province: 27, ID: 321, Name: '南投县' },
  { Province: 27, ID: 322, Name: '基隆市' },
  { Province: 27, ID: 323, Name: '新竹市' },
  { Province: 27, ID: 324, Name: '嘉义市' },
  { Province: 27, ID: 325, Name: '新北市' },
  { Province: 27, ID: 326, Name: '宜兰县' },
  { Province: 27, ID: 327, Name: '新竹县' },
  { Province: 27, ID: 328, Name: '桃园县' },
  { Province: 27, ID: 329, Name: '苗栗县' },
  { Province: 27, ID: 330, Name: '彰化县' },
  { Province: 27, ID: 331, Name: '嘉义县' },
  { Province: 27, ID: 332, Name: '云林县' },
  { Province: 27, ID: 333, Name: '屏东县' },
  { Province: 27, ID: 334, Name: '台东县' },
  { Province: 27, ID: 335, Name: '花莲县' },
  { Province: 27, ID: 336, Name: '澎湖县' },
]
//仅省市选择
for (const provinceItem of provinceData) {
  twareasDatazh.push({
    value: provinceItem.ID, // 省份code值
    label: provinceItem.Name, // 省份汉字
    children: [],
  })
}
for (const provinceItem of twareasDatazh) {
  for (const cityItem of cityData) {
    if (cityItem.Province === provinceItem.value) {
      provinceItem.children.push({
        value: cityItem.ID,
        label: cityItem.Name,
      })
    }
  }
}
export default twareasDatazh



// WEBPACK FOOTER //
// ./src/utils/twareaszh.js